import { ref } from 'vue';

/**
 * @typedef {Object} SortOptions
 * @property {string} [initialSortBy] - Initial field to sort by
 * @property {('asc'|'desc'|'none')} [initialSortDirection] - Initial sort direction
 * @property {Function} [onSortChange] - Callback function triggered when sort parameters change
 */

/**
 * Composable for handling sorting functionality
 * @param {SortOptions} options - Configuration options for sorting
 */
export function useSort(options = {}) {
  const sortBy = ref(options.initialSortBy || 'short_code');
  const sortDirection = ref(options.initialSortDirection || 'asc'); // asc, desc, none

  function toggleSort(key) {
    if (sortBy.value !== key) {
      sortDirection.value = 'none'; // Reset the sort order if the column is changed
    }

    // Set the column to sort by
    sortBy.value = key;

    // Cycle through sort orders: asc → desc → none → asc
    if (sortDirection.value === 'asc') {
      sortDirection.value = 'desc';
    } else if (sortDirection.value === 'desc') {
      sortDirection.value = 'none';
    } else {
      sortDirection.value = 'asc';
    }

    // Refresh data with new sort parameters
    options.onSortChange?.();
  }

  return {
    sortBy,
    sortDirection,
    toggleSort,
  };
}
